import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ui_multichange_planpicker~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/fasting/__b'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_ui_multichange_planpicker~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/fasting/__b'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_ui_multichange_planpicker~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-walking/__b'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_ui_multichange_planpicker~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-tai-chi-walking-v2/__b'
					),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_ui_multichange_planpicker~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-tai-chi-walking-v2-al/__b'
					),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ui_multichange_planpicker~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/fasting/__c'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_ui_multichange_planpicker~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/fasting/__c'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_ui_multichange_planpicker~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-walking/__c'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_ui_multichange_planpicker~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-tai-chi-walking-v2/__c'
					),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_ui_multichange_planpicker~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-tai-chi-walking-v2-al/__c'
					),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ui_multichange_planpicker~3
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/fasting/__d'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_ui_multichange_planpicker~3
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/fasting/__d'
					),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_ui_multichange_planpicker~3
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-walking/__d'
					),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_ui_multichange_planpicker~3
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-tai-chi-walking-v2/__d'
					),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_ui_multichange_planpicker~3
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/activity-female-tai-chi-walking-v2-al/__d'
					),
			},
		},
	},
]

export default config
